import React, {useEffect} from 'react';
import CardsContent from "./cards-content.jsx";
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const GeneralChartsContent = ({ data, boName, collapsed }) => {

    const graphics = data?.apreehension_graphics;

    const charts = [
        {
            id: 'type-apprehensions',
            title: 'Apreensões por tipo',
            data: graphics?.apprehensions_type,
            exportTitle: 'Apreensões por tipo',
            formatter: (value) => value.type
        },
        {
            id: 'subtype-apprehensions',
            title: 'Apreensões por subtipo',
            data: graphics?.apprehensions_subtype,
            exportTitle: 'Apreensões por subtipo',
            formatter: (value) => value.type
        },
        {
            id: 'bos-apprehensions',
            title: `Apreensões por ${boName}`,
            data: graphics?.apprehensions_bo,
            exportTitle: `Apreensões por ${boName}`,
            formatter: (value) => value.type
        },
        {
            id: 'nature-apprehensions',
            title: 'Apreensões por natureza',
            data: graphics?.aprrehensions_nature,
            exportTitle: 'Apreensões por natureza',
            formatter: (value) => ReportUtils.formatText(value.type)
        },
        {
            id: 'neighborhood-apprehensions',
            title: 'Apreensões por bairro',
            data: graphics?.apprehensions_neighborhood,
            exportTitle: 'Apreensões por bairro',
            formatter: (value) => ReportUtils.formatText(value.type)
        }
    ];

    useEffect(() => {

        charts.forEach(chart => {

            if (!chart.data) return;

            const labels = [];
            const values = [];

            chart.data.forEach(element => {
                labels.push(chart.formatter(element));
                values.push(element.qty);
            });

            GraphicUtils.barChart(chart.id, values.slice(0, 10), labels.slice(0, 10), false);
            labels.length > 0 && ReportUtils.createExportableTable(labels, values, chart.exportTitle);

        });

    }, [graphics]);

    const isDuoChart = (chart) => {
        return (chart?.data?.length || 0) <= 3;
    };

    const renderedCharts = [];

    for (let index = 0; index < charts.length; index++) {
        const currentChart = charts[index];
        const nextChart = charts[index + 1];

        const currentIsDuo = isDuoChart(currentChart);
        const nextIsDuo = nextChart && isDuoChart(nextChart);

        if (currentIsDuo && nextIsDuo) {

            renderedCharts.push(
                <React.Fragment key={currentChart.id}>

                    <div className="row">

                        <div className="chart-report duo-bar-chart">
                            <span className="chart-title">{currentChart.title}{currentChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                            <div className="mt-3" id={currentChart.id}></div>
                        </div>

                        <div className="chart-report duo-bar-chart">
                            <span className="chart-title">{nextChart.title}{nextChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                            <div className="mt-3" id={nextChart.id}></div>
                        </div>

                    </div>

                    { index !== charts.length - 2 &&
                        <div className="chart-divisor"/>
                    }

                </React.Fragment>
            );

            index++;
        }

        else {

            renderedCharts.push(
                <React.Fragment key={currentChart.id}>

                    <div className="chart-report">
                        <span className="chart-title"> {currentChart.title} {currentChart.data?.length >= 10 ? ' (TOP 10)' : ''}</span>
                        <div className="mt-3" id={currentChart.id}></div>
                    </div>

                    { index !== charts.length - 1 &&
                        <div className="chart-divisor"/>
                    }

                </React.Fragment>
            );
        }
    }

    return (
        <>
            <div id="general">

                <div className="report-divisor mb-6">
                    <span className="divisor-title">
                        VISÃO GERAL
                    </span>
                </div>

                <CardsContent key={`cards-${collapsed}`} data={data} boName={boName}/>

                {renderedCharts}

            </div>
        </>
    );
};

export default GeneralChartsContent;